<template>
	<button :type="type" class="button" :class="componentClass">
		<div v-if="!isLoading">{{ $t(label) }}</div>
		<div v-if="isLoading" class="lds-ellipsis">
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
	</button>
</template>

<script>
export default {
	name: 'FormButton',
	props: {
		componentClass: {
			type: String,
			default: '',
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
		label: {
			type: String,
			required: true,
		},
		type: {
			type: String,
			default: 'submit',
			validator: function (value) {
				return ['submit', 'reset'].indexOf(value) !== -1
			},
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/FormButton.vue